import { grey } from "@mui/material/colors";
import { DataGrid } from "@mui/x-data-grid";
import { converAttrToDatagridCol, datatypes, inputTypes } from "data/globalData";
import { totalSizeRatioColumn } from "../../data";
import { convertSizeStringToStandardInputFormat, orderQtyStaticColumns } from "../data";

import { Box, Typography, Stack } from "@mui/material";
import DisplayTable from "components/ReusableComponents/DisplayTable";

const ChannelQtyWithSizeRatio = ({
	tableColumns = [],
	channel,
	channelQtyData,
	handleDataChange,
	allChannels,
	allSizes,
	editMode = false,
}) => {
	const tableRowsState =
		channelQtyData
			.filter((row) => row.channel === channel)
			.reduce((acc, curr) => {
				const { id, channel, size, size_qty_precent, channel_total_qty, channel_store_grade } = curr;
				acc["id"] = id;
				acc[size] = size_qty_precent;
				acc[orderQtyStaticColumns.channel_total_qty.key] = channel_total_qty;
				acc[orderQtyStaticColumns.channel_store_grade.key] = channel_store_grade;
				acc[totalSizeRatioColumn.key] = isNaN(acc[totalSizeRatioColumn.key])
					? 0 + +size_qty_precent
					: acc[totalSizeRatioColumn.key] + +size_qty_precent;

				console.log(acc, curr, "dsfgvsdjfskdf");
				return acc;
			}, {}) ?? {};

	const handleRowDataChange = (newRow, oldRow) => {
		return handleDataChange(newRow, oldRow, channel);
	};

	const sizeQtyDisplayColumns = [
		{
			name: "Size",
			key: "size",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.ENTER.key,
			renderHeader: (col) => (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						width: "100%",
						alignItems: "center",
						background: grey[400],
						p: 1,
						boxSizing: "border-box",
					}}>
					<span>{col.name}</span>
				</Box>
			),
		},
		{
			name: "Size Qty",
			key: "size_qty",
			data_type: datatypes.STRING.key,
			input_type: inputTypes.ENTER.key,
			renderHeader: (col) => (
				<Box
					sx={{
						display: "flex",
						justifyContent: "center",
						width: "100%",
						alignItems: "center",
						background: grey[400],
						p: 1,
						boxSizing: "border-box",
					}}>
					<span>{col.name}</span>
				</Box>
			),
		},
	];
	return (
		<Stack width="500px" spacing={2}>
			<Box>
				<Typography variant="h6" mr={2}>
					Size Ratio -{channel}
				</Typography>
				<DataGrid
					rows={tableRowsState ? [tableRowsState] : []}
					// getRowId={(row) => row.id}
					columns={tableColumns.map((col) => converAttrToDatagridCol(col))}
					sx={{
						width: "100%",
						// maxHeight: 250,
						"& .MuiDataGrid-row": {
							cursor: "pointer",
						},
						"& .MuiDataGrid-row:hover": {
							backgroundColor: "transparent",
						},
						"& .MuiDataGrid-columnHeader": {
							cursor: "pointer",
							background: grey[400],
							textTransform: "uppercase",
						},
						"& .MuiDataGrid-cell": {
							padding: 0,
						},
					}}
					density="compact"
					disableRowSelectionOnClick
					pagination={false} // Remove footer
					hideFooter={true}
					showCellVerticalBorder
					showColumnVerticalBorder
					isCellEditable={({ row }) => editMode}
					processRowUpdate={handleRowDataChange}
					autoHeight
				/>
			</Box>

			<Box width={300}>
				<Typography variant="body1" mr={2}>
					Order Qty
				</Typography>
				<DisplayTable
					size="small"
					textAlign="center"
					columns={sizeQtyDisplayColumns}
					rows={[
						{
							size: "total",
							size_qty: channelQtyData
								?.filter((row) => row.channel === channel)
								.map((row) => +row.size_qty)
								.reduce((acc, curr) => acc + curr, 0),
						},
						...channelQtyData
							?.filter((row) => row.channel === channel)
							.map((row) => {
								let { size, size_qty, ...rest } = row;

								return { size, size_qty };
							}),
					]}
				/>
			</Box>
		</Stack>
	);
};

export default ChannelQtyWithSizeRatio;
